import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { useTranslation } from 'react-i18next';

export const Meats = () => {
  const { t } = useTranslation('home');
  const cuts = t('meats.cuts', { returnObjects: true }) as Array<{
    name: string;
    description: string;
    origin: string;
  }>;

  return (
    <section id="carni" className="bg-card py-32 px-6" aria-labelledby="carni-heading">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24 items-center">
          <ScrollReveal>
            <div className="relative overflow-hidden">
              <img
                src="/img/DSC09243 (2024-04-22T17_55_05.360).JPG"
                alt={t('meats.imageAlt')}
                className="w-full object-cover aspect-[4/5]"
                loading="lazy"
                decoding="async"
                width="800"
                height="1000"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
            </div>
          </ScrollReveal>

          <div>
            <ScrollReveal>
              <span className="mb-4 inline-block text-sm font-light uppercase tracking-[0.3em] text-primary">
                {t('meats.label')}
              </span>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <h2 id="carni-heading" className="mb-8 text-4xl font-semibold text-foreground md:text-5xl">
                {t('meats.title')}
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <p className="mb-12 text-lg font-light text-muted-foreground">{t('meats.subtitle')}</p>
            </ScrollReveal>

            <div className="space-y-8">
              {cuts.map((cut, index) => (
                <ScrollReveal key={cut.name} delay={200 + index * 100}>
                  <div className="group border-b border-border pb-6 transition-colors hover:border-primary">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                          {cut.name}
                        </h3>
                        <p className="mt-1 text-muted-foreground">{cut.description}</p>
                      </div>
                      <span className="text-xs uppercase tracking-wider text-primary text-right whitespace-pre-line">
                        {cut.origin.replace(' ', '\n')}
                      </span>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
